import { IUseHistoryOfSearchResponse } from './models/types';

export const useHistoryOfSearch = (): IUseHistoryOfSearchResponse => {
  const historyName = 'mainSearchHistory';

  const getSearchHistory = (): string[] => {
    const historyString = localStorage.getItem(historyName);
    let historyArray: string[] = [];
    if (historyString) {
      historyArray = JSON.parse(historyString);
    }
    return historyArray;
  };

  const setSearchHistory = (value: string) => {
    let historyArray = getSearchHistory();
    if (!historyArray.includes(value)) historyArray = [value, ...historyArray];
    if (historyArray.length > 3) {
      historyArray.splice(3, historyArray.length);
    }
    const historyString = JSON.stringify(historyArray);
    localStorage.setItem(historyName, historyString);
  };

  const deleteCurrentHistory = (value: string, teacherId?: string) => {
    let clearedValue = (value as string).replace(/h_/g, '');
    if (teacherId) {
      clearedValue += `;${teacherId}`;
    }
    const historyArray = getSearchHistory();
    const filteredArray = historyArray.filter((item) => item !== clearedValue);
    const historyString = JSON.stringify(filteredArray);
    localStorage.setItem(historyName, historyString);
  };

  const filterHistory = (value: string): string[] => {
    const history = getSearchHistory();
    return history.filter((item) => {
      if (item.includes(';')) {
        return item.split(';')[0].toLowerCase().includes(value.toLowerCase());
      } else {
        return item.toLowerCase().includes(value.toLowerCase());
      }
    });
  };

  return {
    getSearchHistory,
    setSearchHistory,
    deleteCurrentHistory,
    filterHistory,
  };
};
